import { TParamsObrigatorios } from "../../../../types/api/configuracoes/detalhar-usuario";


export const PARAM_LABELS: Record<TParamsObrigatorios, string> = {
  loja_id: "Loja",
  vendedor_id: "Vendedor",
  condicoes_pagamento_blocked_ids: "Condições de Pagamento",
  limite_alcada: "Limite da Alçada",
  publicos_permitidos: "Público",
};

export const PUBLICO_LABELS: Record<string, string> = {
  C: "Cliente",
  F: "Fornecedor",
  E: "Empregado",
  A: "Associado",
};
